import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "You want to know more about me",
    detail:
      "My interest in computer science began around 5 or 6 years ago when I first came into contact with computer coding in school while creating a small website.",
  },
  {
    icon: <MdCancel />,
    heading: "Biography is the only true history",
    detail:
      "From there on, I was captivated. I started working on small projects of my own, creating other websites and a simple calculator I have learned small pieces of codes from several languages through my brother lectures that are available online freely as well as through other.",
  },
  {
    icon: <MdAnalytics />,
    heading: "In the end only story will remain",
    detail:
      "For me, working on computer code is my way of being creative, since I find it difficult to be creative in more common ways such as drawing. Every time I write a piece of computer code, I get the feeling i have created a piece of art and reading computer code, to me, feels like looking at a piece of art.",
  },
];
export default data;